import Vue from 'vue'

import Cookies from 'js-cookie'

import axios from 'axios'

import qs from 'qs'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import '@/styles/common.scss' // global css
import '@/styles/element-ui.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './lang' // Internationalization
import './icons' // icon
import './permission' // permission control
import './utils/errorLog' // error log

import * as filters from './filters' // global filters

import { mockXHR } from '../mock' // simulation data


import Print from 'vue-print-nb-jeecg'
Vue.use(Print);


import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

// mock api in github pages site build
// if (process.env.NODE_ENV === 'production') { mockXHR() }

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.prototype.$axios = axios

Vue.prototype.qs = qs

router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
